module.exports = __webpack_public_path__ + "media/images/apple-touch-icon-76x76-c8d91e1b14ce428804205692186c2dd0.png";